import { Injectable, signal } from '@angular/core';

export interface SipEditorMetadata {
  sipSubmissionId: string;
  sipVersionId: string;
  espSubmissionId: string;
  espVersionId: string;
  stationId: string;
  mode?: 'generate' | 'view';
}

@Injectable({ providedIn: 'root' })
export class EditorStateService {
  isEditorOpen = signal(false);
  sipMetadata = signal<SipEditorMetadata | null>(null);
  isSaved = signal(false);
  isSaving = signal(false);
  isGenerated = signal(false);

  open(): void {
    this.isEditorOpen.set(true);
    this.isSaved.set(false);
    this.isSaving.set(false);
  }

  close(): void {
    this.isEditorOpen.set(false);
    this.sipMetadata.set(null);
    this.isSaved.set(false);
    this.isSaving.set(false);
    this.isGenerated.set(false);
  }
}
